module.exports = __webpack_public_path__ + "static/038-c4d4585329291728383e0915fa8c0e02.jpg";